/* tslint:disable:max-line-length */
/* tslint:disable:ter-max-len */
type Dictionary = typeof en;

export const en = {
  'common.reservation_number': 'Reservation number',
  'common.last_name': 'Last name',
  'common.flight': 'Flight',
  'common.voucher_redeemed': 'Voucher redeemed',
  'common.done': 'Done',
  'common.email': 'Email',
  'common.errors.list': 'The following errors were found:',
  'common.errors.general': 'Please fix the errors above.',
  'common.contact': 'Contact',
  'common.adult': 'Adult',
  'common.child': 'Child',

  'chrome.footer_html': '&nbsp;',

  'login.header': 'Verify your identity',
  'login.subheader': 'Verify your identity to claim your voucher',
  'login.button': 'Claim voucher',

  'expired.header': 'Welcome, {firstName}',
  'expired.subheader': 'Your voucher has expired',
  'expired.text': 'The 10 days you had to redeem this voucher expired on:',

  'flight_info.header': 'Delayed flight info',
  'flight_info.direct': 'Direct',
  'flight_info.delay_time': 'Delay time',
  'flight_info.operated_by': 'Operated by:',
  'flight_info.passenger_details.header': 'Passenger details',
  'flight_info.passenger_details.text': 'Select the vouchers you want to redeem.',
  'flight_info.redeem_voucher': 'Redeem voucher',
  'flight_info.too_late': 'Redemption period ended',
  'flight_info.send_again': 'Send again',
  'flight_info.redeem_error': 'Error redeeming voucher',

  'send.header': 'Send Voucher',

  'send.details.header': 'Compensation details',
  'send.details.delay_time': 'Delay time:',
  'send.details.compensation': 'Compensation:',
  'send.details.voucher': 'Voucher:',
  'send.details.redeemed_on': 'Redeemed on:',
  'send.details.sent_to': 'Sent to: ',

  'send.form.header': 'Send voucher to',
  'send.form.button': 'Send Voucher',
  'send.form.error_html': 'Voucher failed to send. Please <a target="_blank" href="https://cms.volaris.com/en/traveling-with-volaris/payment-options/pago-en-call-center/">contact our call center</a>.',
  'send.form.success': 'Voucher sent to {address}.',
  'Could not locate PNR and/or last name.': 'Could not locate PNR and/or last name.',
  'Error looking up booking. Please try again later.': 'Error looking up booking. Please try again later.',
  'Unfortunately, your booking is not eligible for a voucher.': 'Unfortunately, your booking is not eligible for a voucher.',
  'This field is required.': 'This field is required.',
  'Unable to redeem voucher.': 'Unable to redeem voucher.',
  'Passenger does not exist.': 'Passenger does not exist.',
  'Enter a valid email address.': 'Enter a valid email address.',
};

export const es: Dictionary = {
  'common.reservation_number': 'Clave de reservación',
  'common.last_name': 'Apellido',
  'common.flight': 'Vuelo',
  'common.voucher_redeemed': 'Vocuher redimido',
  'common.done': 'Finalizado',
  'common.email': 'E-mail',
  'common.errors.list': 'Han ocurrido algunos errores:',
  'common.errors.general': 'Por favor verifica la información.',
  'common.contact': 'Contacto',
  'common.adult': 'Adulto',
  'common.child': 'Menor',

  'chrome.footer_html': '&nbsp;',

  'login.header': 'Verificar identidad',
  'login.subheader': 'Verifica tu identidad para reclamar tu voucher',
  'login.button': 'Reclamar voucher',

  'expired.header': '¡Bienvenido, {firstName}!',
  'expired.subheader': 'Tu crédito electrónico ha expirado',
  'expired.text': 'Los 10 días para redimir tu voucher expiran:',

  'flight_info.header': 'Información de vuelo demorado',
  'flight_info.direct': 'Directo',
  'flight_info.delay_time': 'Tiempo de demora',
  'flight_info.operated_by': 'Operado por:',
  'flight_info.passenger_details.header': 'Detalles de pasajero',
  'flight_info.passenger_details.text': 'Selecciona el crédito a redimir.',
  'flight_info.redeem_voucher': 'Redimir voucher',
  'flight_info.too_late': 'El período para redimir tu voucher ha expirado',
  'flight_info.send_again': 'Reenviar',
  'flight_info.redeem_error': 'No fue posible redimiertu voucher',

  'send.header': 'Enviar voucher',

  'send.details.header': 'Detalles de compensación',
  'send.details.delay_time': 'Tiempo de demora:',
  'send.details.compensation': 'Compensación:',
  'send.details.voucher': 'Voucher:',
  'send.details.redeemed_on': 'Redimido en:',
  'send.details.sent_to': 'Enviar a: ',

  'send.form.header': 'Enviar crédito electrónico a:',
  'send.form.button': 'Enviar Voucher',
  'send.form.error_html': 'No fue posible enviar el voucher. Por favor <a target="_blank" href="https://cms.volaris.com/es/viajando-con-volaris/opciones-de-pago/reserva-en-call-center/?countryflag=Mexico">llama a nuestro Call center</a>.',
  'send.form.success': 'Voucher enviado a {address}.',
  'Could not locate PNR and/or last name.': 'No se puede encontrar su reserva y/o su apellido.',
  'Error looking up booking. Please try again later.': 'Error localizando su reserva.  Por favor intente más tarde.',
  'Unfortunately, your booking is not eligible for a voucher.': 'Desafortunadamente, su reserva no es elegible para un vocuher.',
  'This field is required.': 'Este campo es requerido.',
  'Unable to redeem voucher.': 'No se puede redimir su voucher.',
  'Passenger does not exist.': 'Pasajero no existe.',
  'Enter a valid email address.': 'Introduzca una dirección de correo electrónico válida.',
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/i18n/dictionaries.ts